const DuotoneFilters = ({duotone,uniqueId}) => {

    if(duotone === undefined || duotone === null || duotone.length !== 2) {
        return null;
    }

    const colorToRGBArray = (color) => {
        if (color.startsWith("#")) {
            const r = parseInt(color.substring(1, 3), 16) / 255;
            const g = parseInt(color.substring(3, 5), 16) / 255;
            const b = parseInt(color.substring(5, 7), 16) / 255;
            return [r.toFixed(2), g.toFixed(2), b.toFixed(2)];
        } else if (color.startsWith("rgb")) {
            const [r, g, b] = color
                .replace(/[^\d,]/g, "")
                .split(",")
                .map((v) => parseInt(v.trim()) / 255);
            return [r.toFixed(2), g.toFixed(2), b.toFixed(2)];
        }
        return [0, 0, 0]; // fallback in case of invalid input
    };
    

    const [r1, g1, b1] = colorToRGBArray(duotone[0]);
    const [r2, g2, b2] = colorToRGBArray(duotone[1]);

    return (
     <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
            <filter id={`duotone-filter-${uniqueId}`}>
                <feColorMatrix
                    type="matrix"
                    values="0.33 0.33 0.33 0 0
                            0.33 0.33 0.33 0 0
                            0.33 0.33 0.33 0 0
                            0 0 0 1 0"
                />
                <feComponentTransfer colorInterpolationFilters="sRGB">
                    <feFuncR type="table" tableValues={`${r1} ${r2}`} />
                    <feFuncG type="table" tableValues={`${g1} ${g2}`} />
                    <feFuncB type="table" tableValues={`${b1} ${b2}`} />
                    <feFuncA type="table" tableValues="0 1" />
                </feComponentTransfer>
            </filter>
        </svg>
    );
};

export default DuotoneFilters;